// Central dayjs instance with the plugins the app relies on, so every importer
// gets a consistent, fully-configured dayjs (replaces moment). dayjs uses the
// same format tokens as moment, so existing format strings are unchanged.
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import duration from "dayjs/plugin/duration";
import customParseFormat from "dayjs/plugin/customParseFormat";

dayjs.extend(utc); // .utcOffset()
dayjs.extend(duration); // dayjs.duration()
dayjs.extend(customParseFormat); // dayjs(str, "DD-MM-YYYY HH:mm:ss")

export default dayjs;
